// Path: src/subscreens/mechanicadmin/earnings/TopupSuccess.jsx
import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiCheckCircle } from "react-icons/fi";
import axios from "axios";
import AppContext from "../../../../context/AppContext.js";
import MechanicAdminLayout from "../../../../layout/mechanic/MechanicMasterLayout.js";
import "../../../../assets/css/mechanic/earning/Earning.css";

const TopupSuccess = () => {
  const navigate = useNavigate();
  const { baseUrl, authToken } = useContext(AppContext);
  const topupSaved = useRef(false);
  const [status, setStatus] = useState("saving"); // saving | done | error

  useEffect(() => {
    if (topupSaved.current) return;
    topupSaved.current = true;

    const pendingTopup = JSON.parse(localStorage.getItem("pendingTopup"));

    if (!pendingTopup) {
      setStatus("done");
      return;
    }

    const formData = new FormData();
    formData.append("srmechanicadmin_id", pendingTopup.srmechanicadmin_id);
    formData.append("amount", pendingTopup.amount);
    formData.append("paymentmethod", pendingTopup.paymentmethod);
    formData.append("status", pendingTopup.status);

    axios
      .post(`${baseUrl}/mechanicadmin/topup/topUpRequests`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${authToken}`,
        },
      })
      .then((res) => {
        console.log(res.data);
        localStorage.removeItem("pendingTopup");
        setStatus("done");
      })
      .catch((err) => {
        console.log(err);
        setStatus("error");
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <MechanicAdminLayout>
      <div className="me-page" style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "60vh" }}>
        <div style={{ textAlign: "center", maxWidth: 420 }}>
          <div className="me-topup-success-icon" style={{ margin: "0 auto 1.2rem" }}>
            <FiCheckCircle size={48} />
          </div>
          <h2 style={{ fontFamily: "'Baloo 2', cursive", fontWeight: 700, marginBottom: 8 }}>
            {status === "saving" && "Confirming your payment..."}
            {status === "done" && "Payment Successful!"}
            {status === "error" && "Payment received, but something went wrong"}
          </h2>
          <p style={{ color: "#888", marginBottom: 24 }}>
            {status === "done" &&
              "Your topup request has been submitted and is pending approval."}
            {status === "error" &&
              "Please contact support with your payment confirmation if this persists."}
          </p>
          <button
            className="me-topup-confirm-btn"
            style={{ width: "auto", padding: "10px 28px" }}
            onClick={() => navigate("/mechanic-admin/earnings")}
          >
            Back to Earnings
          </button>
        </div>
      </div>
    </MechanicAdminLayout>
  );
};

export default TopupSuccess;